<template>
  <div class="bank-card-page">
    <!-- 头部 -->
    <div class="header">
      <div class="back-btn" @click="goBack">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="title">{{ currentTitle }}</div>
    </div>

    <!-- 空状态页面 -->
    <div v-if="pay_list.length === 0" class="empty-state">
      <div class="illustration-box">
        <img src="../assets/image/bg6.png" style="width: 100%;height: 100%;" alt="">
      </div>
      <div class="empty-text">没有任何记录</div>
      <div class="empty-subtext">拜托拜托 请先添加银行卡</div>
      <button class="add-btn" @click="goAddBankCard">添加银行卡</button>
      <div class="warning-box">
        <div class="warning-title">温馨提示：</div>
        <div class="warning-text">
          您还没有绑定银行卡，一共可以绑定3张银行卡。为了您的资金安全，成功提现的银行卡会自动锁定，无法删除和更改。
        </div>
      </div>
    </div>

    <!-- 银行卡列表页面 -->
    <div v-else class="bank-card-list">
      <div class="card-item" v-for="card in pay_list" :key="card.id">
        <div class="card-content">
          <div class="bank-name">{{ card.acc_bank }}</div>
          <div class="account-holder">{{ card.acc }}</div>
          <div class="card-number">{{ formatCardNumber(card.acc_name) }}</div>
        </div>
      </div>
      <button class="add-btn" @click="goAddBankCard">添加银行卡</button>
    </div>

    <!-- 添加银行卡页面 -->
    <!-- <div v-if="currentPage === 'add'" class="add-form">
        <div class="form-item">
          <div class="label">银行</div>
          <div class="input-wrapper">
            <input type="text" placeholder="请选择银行" class="input" />
            <span class="arrow">▼</span>
          </div>
        </div>
        <div class="form-item">
          <div class="label">支行</div>
          <div class="input-wrapper">
            <input type="text" placeholder="请输入支行名称" class="input" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">姓名</div>
          <div class="input-wrapper">
            <input type="text" placeholder="请输入与银行卡相匹配的真实" class="input" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">卡号</div>
          <div class="input-wrapper">
            <input type="text" placeholder="请15-20位输入银行卡号" class="input" maxlength="20" />
          </div>
        </div>
        <button class="submit-btn">提交</button>
        <button class="my-cards-btn" @click="currentPage = 'list'">我的银行卡</button>
      </div> -->

    <!-- 银行卡列表页面 -->
    <!-- <div v-if="currentPage === 'list'" class="card-list">
        <button class="add-btn-top" @click="currentPage = 'add'">添加银行卡</button>
      </div> -->
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router';
import userApi from "@/api/user";
import { onMounted } from 'vue';

onMounted(() => {
  getWithdrawInfo()
})

const router = useRouter()

const goAddBankCard = () => {
  if (pay_list.value.length == 0) {
    router.push({
      path: '/addBankCard'
    })
  }else {
    router.push({
      path: '/AddBankCard',
      query: {
        group_id:1
      }
    })
  }
}

// 格式化银行卡号，每4位添加空格
const formatCardNumber = (cardNumber) => {
  if (!cardNumber) return ''
  return cardNumber.replace(/(.{4})/g, '$1 ').trim()
}

const pay_list = ref([])

const getWithdrawInfo = async () => {
  const res = await userApi.withdrawInfo()
  if (res.code == 1) {
    pay_list.value = res.data.pay_list
  }
}

const currentTitle = computed(() => {
  return '银行卡'
})

const goBack = () => {
  router.go(-1)
}


</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.bank-card-page {
  width: 100%;
  min-height: 100vh;
  background: #0a1128;
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #0f1a3a;
  position: relative;
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  font-weight: 500;
}

/* 初始页面样式 */
.empty-state {
  padding: 40px 20px 20px;
}

.illustration-box {
  width: 270px;
  height: 250px;
  margin: 0 auto 30px;
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bee {
  position: absolute;
  top: 20px;
  right: 50%;
  font-size: 28px;
  animation: float 3s ease-in-out infinite;
}

.wallet-icon {
  width: 100px;
  height: 80px;
  background: linear-gradient(135deg, #e8e8f0 0%, #d0d0dc 100%);
  border-radius: 8px;
  position: relative;
}

.wallet-icon::after {
  content: '';
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 16px;
  background: #f5a5a5;
  border-radius: 3px;
}

.stars,
.dots {
  position: absolute;
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
}

.stars {
  top: 30px;
  left: 30px;
}

.dots {
  bottom: 40px;
  right: 40px;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.empty-text {
  text-align: center;
  font-size: 16px;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.7);
}

.empty-subtext {
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 40px;
}

.add-btn {
  width: calc(100% - 40px);
  margin: 0 20px;
  height: 50px;
  background: linear-gradient(135deg, #00d4ff 0%, #00a8e6 100%);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 30px;
}

.warning-box {
  padding: 0 20px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;
  line-height: 1.6;
}

.warning-title {
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.5);
}

.warning-text {
  color: rgba(255, 255, 255, 0.35);
}

/* 添加银行卡页面样式 */
.add-form {
  padding: 30px 20px;
}

.form-item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.label {
  font-size: 16px;
  margin-bottom: 15px;
  margin-right: 20px;
  color: white;
}

.input-wrapper {
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}

.input {
  /* width: 100%; */
  width: 60vw;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 15px;
  padding-right: 20px;
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.arrow {
  position: absolute;
  right: 0;
  top: 0;
  color: rgba(255, 255, 255, 0.3);
  font-size: 12px;
}

.submit-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #00d4ff 0%, #00a8e6 100%);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 40px;
  margin-bottom: 15px;
}

.my-cards-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #ffb3c1 0%, #ff8fa3 100%);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

/* 银行卡列表页面样式 */
.bank-card-list {
      margin-top: 10px;
}

.card-item {
  width: 95%;
  margin: 0 auto .66667rem;
  background-image: linear-gradient(90deg, #3b9dfd, #3d5179);
  background-size: 100% 100%;
  border-radius: .21333rem;
  /* margin-top: .53333rem; */
  padding: .36rem 1.06667rem;
}

.card-content {
  color: white;
  text-align: left;
}

.bank-name {
    font-size: 25px;
    font-weight: 600;
    margin-bottom: 8px;
    color: white;
    text-align: left;
}

.account-holder {
  font-size: 18px;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.9);
  text-align: left;
}

.card-number {
  font-size: 23px;
  font-weight: 700;
  /* letter-spacing: 2px; */
  color: white;
  font-family: 'Courier New', monospace;
  text-align: left;
}

.card-list {
  padding: 20px;
}

.add-btn-top {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #00d4ff 0%, #00a8e6 100%);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
</style>